import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import ive from './modules/ive'
import query from './modules/query'
import ecard from './modules/ecard'
import photo from './modules/photo'
import cardAuth from './modules/cardAuth'
import preallocation from './modules/preallocation'
import cust_invoice from '@/views/Invoice/Cust/store'
import rabbitcard from '@/views/RabbitCard/store'
import platinumcard from '@/views/PlatinumCard/store'
import capitalpool from '@/views/CapitalPool/store'
import upload from './modules/upload'
import cardBind from './modules/cardBind'
import defaultCorp from './modules/defaultCorp'
import oilSet from './modules/oilSet'
import orderCancel from './modules/orderCancel'
import clearAcc from './modules/clearAcc'
import createCard from './modules/createCard'
import cifNoWhite from '@/views/CifNoWhite/store'
import bill from './modules/bill'
import sharePayment from './modules/sharePayment'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {

    user,
    ive,
    query,
    ecard,
    photo,
    cardAuth,
    preallocation,
    cust_invoice,
    rabbitcard,
    platinumcard,
    capitalpool,
    upload,
    cardBind,
    defaultCorp,
    oilSet,
    orderCancel,
    clearAcc,
    createCard,
    cifNoWhite,
    bill,
    sharePayment
  }
})
